import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../admin/admin.css";

const SideBar = () => {
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const [activeSubmenu, setActiveSubmenu] = useState(null);

  // Auto-expand active dropdown based on current route
  useEffect(() => {
    const path = location.pathname;
    if (path === "/admin/all-reviews" || path.includes("/reviews")) {
      setActiveSubmenu("details");
    } else if (path === "/admin/AllCompanies" || path === "/admin/companies") {
      setActiveSubmenu("Company");
    } else if (path.includes("/subscribers")) {
      setActiveSubmenu("overview");
    }
  }, [location.pathname]);

  const toggleSubmenu = (menuKey) => {
    setActiveSubmenu((prev) => (prev === menuKey ? null : menuKey));
  };

  const toggleSidebar = () => {
    setIsActive(!isActive);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/admin/login");
  };

  return (
    <>
      <div className={`sidebar ${isActive ? "close" : ""}`}>
        <Link className="logo-box text-decoration-none" onClick={toggleSidebar}>
          <img src="/images/Bizwitlogo.svg" alt="Logo" />
        </Link>

        <ul className="sidebar-list">
          {/* Dashboard */}
          <li className={location.pathname === "/admin/dashboard" ? "active" : ""}>
            <div className="title">
              <Link to="/admin/dashboard" className="link">
                <i className="bi bi-grid-3x3"></i>
                <span className="name">Dashboard</span>
              </Link>
            </div>
          </li>

          {/* Users */}
          <li className={location.pathname === "/admin/userlist" ? "active" : ""}>
            <div className="title">
              <Link to="/admin/userlist" className="link">
                <i className="bi bi-person"></i>
                <span className="name">Users</span>
              </Link>
            </div>
          </li>

          {/* Plans */}
          <li className={location.pathname === "/admin/plans" ? "active" : ""}>
            <div className="title">
              <Link to="/admin/plans" className="link">
                <i className="bi bi-bookshelf"></i>
                <span className="name">Plans</span>
              </Link>
            </div>
          </li>

          {/* Reviews Dropdown */}
          <li
            className={`dropdown ${
              activeSubmenu === "details" ? "active" : ""
            }`}
          >
            <div
              className="title"
              onClick={() => toggleSubmenu("details")}
            >
              <div className="link">
                <i className="bi bi-star"></i>
                <span className="name">Reviews</span>
              </div>
              <i className="bi bi-chevron-down"></i>
            </div>
            <div className="submenu">
              <Link
                to="/admin/all-reviews"
                className={`link ${
                  location.pathname === "/admin/all-reviews" ? "sub-active" : ""
                }`}
                onClick={(e) => e.stopPropagation()}
              >
                All Reviews
              </Link>
            </div>
          </li>

          {/* Upload Report */}
          <li className={location.pathname === "/admin/upload" ? "active" : ""}>
            <div className="title">
              <Link to="/admin/upload" className="link">
                <i className="bi bi-file-earmark-arrow-up"></i>
                <span className="name">Upload Report</span>
              </Link>
            </div>
          </li>

          {/* Edit Report */}
          <li
            className={
              location.pathname.startsWith("/admin/report") ? "active" : ""
            }
          >
            <div className="title">
              <Link to="/admin/report/view" className="link">
                <i className="bi bi-file-earmark-spreadsheet"></i>
                <span className="name">Edit Report</span>
              </Link>
            </div>
          </li>

          {/* Company Dropdown */}
          <li
            className={`dropdown ${
              activeSubmenu === "Company" ? "active" : ""
            }`}
          >
            <div
              className="title"
              onClick={() => toggleSubmenu("Company")}
            >
              <div className="link">
                <i className="bi bi-building"></i>
                <span className="name">Company</span>
              </div>
              <i className="bi bi-chevron-down"></i>
            </div>
            <div className="submenu">
              <Link
                to="/admin/AllCompanies"
                className={`link ${
                  location.pathname === "/admin/AllCompanies" ? "sub-active" : ""
                }`}
                onClick={(e) => e.stopPropagation()}
              >
                All Companies
              </Link>
              <Link
                to="/admin/companies"
                className={`link ${
                  location.pathname === "/admin/companies" ? "sub-active" : ""
                }`}
                onClick={(e) => e.stopPropagation()}
              >
                Upload Company Details
              </Link>
            </div>
          </li>

          {/* Contact Us */}
          <li
            className={location.pathname === "/admin/contactUs" ? "active" : ""}
          >
            <div className="title">
              <Link to="/admin/contactUs" className="link">
                <i className="bi bi-card-checklist"></i>
                <span className="name">Contact us</span>
              </Link>
            </div>
          </li>

          {/* Subscribers Dropdown */}
          <li
            className={`dropdown ${
              activeSubmenu === "overview" ? "active" : ""
            }`}
          >
            <div
              className="title"
              onClick={() => toggleSubmenu("overview")}
            >
              <div className="link">
                <i className="bi bi-person-fill"></i>
                <span className="name">Subscribers</span>
              </div>
              <i className="bi bi-chevron-down"></i>
            </div>
            <div className="submenu">
              <Link
                to="/admin/pending/subscribers"
                className={`link ${
                  location.pathname === "/admin/pending/subscribers"
                    ? "sub-active"
                    : ""
                }`}
                onClick={(e) => e.stopPropagation()}
              >
                Pending Subscribers
              </Link>
              <Link
                to="/admin/approved/subscribers"
                className={`link ${
                  location.pathname === "/admin/approved/subscribers"
                    ? "sub-active"
                    : ""
                }`}
                onClick={(e) => e.stopPropagation()}
              >
                Approved Subscribers
              </Link>
            </div>
          </li>

          {/* Logout */}
          <li className="logout">
            <div className="title">
              <button className="link" onClick={handleLogout}>
                <i className="bi bi-box-arrow-left"></i>
                <span className="name">Logout</span>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </>
  );
};

export default SideBar;
